module.exports = __webpack_public_path__ + "static/media/decibel-support.887b5be1.md";